//#region src/components/InlineCode/InlineCode.module.css
var e = "_code_g8fgg_1", t = { code: e };
//#endregion
export { e as code, t as default };
